
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/general-results/[taxonomySlug]/[slug]",
      function () {
        return require("private-next-pages/articles/general-results/[taxonomySlug]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/general-results/[taxonomySlug]/[slug]"])
      });
    }
  